import { render, staticRenderFns } from "./BlogDetailPagination.vue?vue&type=template&id=a8705b7e&"
import script from "./BlogDetailPagination.vue?vue&type=script&lang=js&"
export * from "./BlogDetailPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports